var map = {
	"./PAP_cat_icon_1-to-1.svg": [
		1891,
		29
	],
	"./PAP_cat_icon_1to1-other.svg": [
		1914,
		30
	],
	"./PAP_cat_icon_blog-theme-design.svg": [
		1915,
		31
	],
	"./PAP_cat_icon_book-cover-design.svg": [
		1916,
		32
	],
	"./PAP_cat_icon_brochure-or-menu-design.svg": [
		1917,
		33
	],
	"./PAP_cat_icon_business-card-design.svg": [
		1918,
		34
	],
	"./PAP_cat_icon_business-tagline.svg": [
		1919,
		35
	],
	"./PAP_cat_icon_design-consultation.svg": [
		1892,
		36
	],
	"./PAP_cat_icon_email-design.svg": [
		1920,
		37
	],
	"./PAP_cat_icon_icon-button-and-widget-design.svg": [
		1921,
		38
	],
	"./PAP_cat_icon_illustration-and-graphic-design.svg": [
		1922,
		39
	],
	"./PAP_cat_icon_infographics-design.svg": [
		1923,
		40
	],
	"./PAP_cat_icon_landing-page-design.svg": [
		1924,
		41
	],
	"./PAP_cat_icon_letterhead-and-stationery-design.svg": [
		1925,
		42
	],
	"./PAP_cat_icon_logo-and-business-card-design.svg": [
		1926,
		43
	],
	"./PAP_cat_icon_logo-and-social-media-assets-design.svg": [
		1927,
		44
	],
	"./PAP_cat_icon_logo-design.svg": [
		1928,
		45
	],
	"./PAP_cat_icon_magazine-cover-design.svg": [
		1929,
		46
	],
	"./PAP_cat_icon_merchandise-design.svg": [
		1930,
		47
	],
	"./PAP_cat_icon_mobile-ui-design.svg": [
		1931,
		48
	],
	"./PAP_cat_icon_naming-a-business-or-product.svg": [
		1932,
		49
	],
	"./PAP_cat_icon_other-clothing-design.svg": [
		1933,
		50
	],
	"./PAP_cat_icon_outdoor-or-signage-design.svg": [
		1934,
		51
	],
	"./PAP_cat_icon_package-graphics.svg": [
		1935,
		52
	],
	"./PAP_cat_icon_packaging-design.svg": [
		1936,
		53
	],
	"./PAP_cat_icon_postcard-or-flyer-design.svg": [
		1937,
		54
	],
	"./PAP_cat_icon_poster-design.svg": [
		1938,
		55
	],
	"./PAP_cat_icon_presentation-design.svg": [
		1939,
		56
	],
	"./PAP_cat_icon_product-design.svg": [
		1940,
		57
	],
	"./PAP_cat_icon_social-media-assets-design.svg": [
		1941,
		58
	],
	"./PAP_cat_icon_t-shirt-design.svg": [
		1942,
		59
	],
	"./PAP_cat_icon_tattoo-design.svg": [
		1943,
		60
	],
	"./PAP_cat_icon_vehicle-wrap-design.svg": [
		1944,
		61
	],
	"./PAP_cat_icon_wall-mural-art-design.svg": [
		1945,
		62
	],
	"./PAP_cat_icon_web-banner-design.svg": [
		1946,
		63
	],
	"./PAP_cat_icon_website-design.svg": [
		1947,
		64
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1874;
module.exports = webpackAsyncContext;